export * from "./ZatcaIntegration";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { Spin } from "antd";
import { ErrorFallback } from "../../patterns";
import { ZatcaIntegrationProps } from "./ZatcaIntegration.types";

export const ZatcaIntegrationLoadable = lazy(
  () => import("./ZatcaIntegration")
);

export const ZatcaIntegration = (props: ZatcaIntegrationProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <Spin size="large" />
          </div>
        }
      >
        <ZatcaIntegrationLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
